import * as angular from "angular";
import { VoterFileDataProvider } from "../../data-provider/voter-file.dp";
import { Campaign } from "../../models/campaign.model";
import { DialogUtils } from "../../helper/dialog.helper";

let ChooseCampaignColumnDialogComponent = {
    selector: "vcChooseCampaignColumnDialog",
    templateUrl:
        "/angular/components/voter-file/choose-campaign-column.component.html",
    bindings: {
        columns: "=",
        erid: "=",
        firstTime: "=",
        selectedColumn: "=?",
    },
    controller: class ChooseCampaignColumnDialogController {
        // * bindings for typescript compiler *
        public columns: any;
        public erid: any;
        public firstTime: any;
        public selectedColumn: any;
        // ************************************

        private readonly $scope: any;
        private readonly dialog: DialogUtils;
        private dataProvider: VoterFileDataProvider;
        private $window: any;
        private readonly modelsUtils: any;

        public step = 1;
        public loading = false;
        public campaigns: Campaign[];
        public unmatchedCampaigns: Campaign[];

        constructor(
            $scope: any,
            DialogUtils: DialogUtils,
            VoterFileDataProvider: VoterFileDataProvider,
            __app_type: string,
            $window: any,
            ModelsUtils: any
        ) {
            this.$scope = $scope;
            this.dialog = DialogUtils;
            this.dataProvider = VoterFileDataProvider;
            this.$window = $window;
            this.modelsUtils = ModelsUtils;

            this.$scope.$on("$routeChangeStart", () => this.dialog.cancel());
        }

        $onInit() {
            this.selectedColumn = this.selectedColumn ?? null;
        }

        selectColumn(column: object): void {
            this.selectedColumn = column;
        }

        confirm(): void {
            if (this.step === 1) {
                this.loading = true;
                this.dataProvider
                    .getCampaignColumnValues(
                        this.erid,
                        this.selectedColumn["icvalue"]
                    )
                    .then((data: any[]) => {
                        this.step = 2;
                        this.campaigns = [];
                        data.forEach((campaignData: object) => {
                            this.campaigns.push(
                                this.modelsUtils.campaign(campaignData)
                            );
                        });
                        this.selectedColumn.campaigns = this.campaigns;
                        this.unmatchedCampaigns = this.campaigns.filter(
                            (campaign: Campaign) => !campaign.exists
                        );
                    });
            } else {
                if (this.unmatchedCampaigns.length == this.campaigns.length) {
                    this.cancel();
                } else {
                    this.dialog.hide(this.selectedColumn);
                }
            }
        }

        changeStep(step: number): void {
            this.step = step;
        }

        cancel(): void {
            this.dialog.cancel();
            if (this.firstTime) {
                this.$window.location = "./leader.php/#/leader_voterfiles/";
            }
        }
    },
};

angular
    .module("voterFile", ["angularFileUpload"])
    .component(
        ChooseCampaignColumnDialogComponent.selector,
        ChooseCampaignColumnDialogComponent
    );
